import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'

import {SelectStyleAction} from "@src/components/helpers/SelectConfigs"
import {trans} from '@utils'

interface MultiBehaviorSelectProps {
  value: any
  onChangeState?: (value: any) => void
  onChange: (value: any) => void
  isColored?: boolean
  styles?: any
  className?: string
  classNamePrefix?: string
  options?: any
  isMulti?: boolean
  placeholder?: string

}

const MultiBehaviourSelect: React.FC<MultiBehaviorSelectProps> = React.forwardRef((props, ref) => {
  const {value, onChangeState = () => {}, onChange = () => {}, ...restProps} = props
  useEffect(() => {
    onChangeState(value)
  }, [value])
  return (
    <Select
      className='react-select'
      classNamePrefix='select'
      placeholder={trans('gen.reactSelect.placeholder')}
      styles={SelectStyleAction(props)}
      value={value}
      onChange={e => {
        onChange(e)
      }}
      {...restProps}
    />
  )
})

export default MultiBehaviourSelect
